"use strict";

var _ExceptionMessages = _interopRequireDefault(require("./ExceptionMessages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Classe de códigos de exceção padrão do Easy Delivery
 */
class ExceptionCode {
  //DEFAULT
  static get DEFAULT() {
    return 1000;
  }

  static get REQUIRED_FIELD() {
    return 1001;
  }

  static get ENVIRONMENT_NOT_DEFINED() {
    return 1002;
  }

  static get ENVIRONMENT_NOT_FOUND() {
    return 1003;
  }

  static get USER_NOT_DEFINED() {
    return 1004;
  }

  static get USER_NOT_FOUND() {
    return 1005;
  }

  static get NOT_ALLOWED() {
    return 1006;
  }

  static get ENVIROMENT_NAME_ALREADY_EXISTS() {
    return 1007;
  }

  static get ENVIRONMENT_ENDPOINT_UNDEFINED() {
    return 1008;
  }

  static get ACCOUNT_LOGIN_ERROR() {
    return 1100;
  }

  static get ACCOUNT_DELETE_FAIL() {
    return 1101;
  }

  static get ACCOUNT_INVALID_EMAIL_FORMAT() {
    return 1102;
  }

  static get ACCOUNT_INVALID_PHONE() {
    return 1103;
  }

  static get ACCOUNT_INVALID_DDD() {
    return 1104;
  }

  static get ACCOUNT_PASSWORD_MINIMUM() {
    return 1105;
  }

  static get ACCOUNT_EMAIL_EXISTS() {
    return 1106;
  }

  static get ACCOUNT_NAME_REQUIRED() {
    return 1107;
  }

  static get ACCOUNT_SURNAME_REQUIRED() {
    return 1108;
  }

  static get ACCOUNT_INVALID_BIRTHDATE() {
    return 1109;
  }

  static get ACCOUNT_NOT_ASSOCIATED() {
    return 1110;
  }

  static get ACCOUNT_ALREADY_ASSOCIATED() {
    return 1111;
  }

  static get ACCOUNT_PASSWORD_NOT_MATCH() {
    return 1112;
  }

  static get ACCOUNT_INVALID_FACEBOOK_ID() {
    return 1113;
  }

  static get ACCOUNT_EMAIL_NOT_FOUND() {
    return 1114;
  }

  static get ACCOUNT_INVALID_URL() {
    return 1115;
  }

  static get ACCOUNT_RECOVER_EMAIL_FAIL() {
    return 1116;
  }

  static get ACCOUNT_RECOVER_TOKEN_NOT_MATCH() {
    return 1117;
  }

  static get ACCOUNT_EXPIRED_RECOVER_PASSWORD() {
    return 1118;
  }

  static get ACCOUNT_INVALID_DATE() {
    return 1119;
  }

  static get ACCOUNT_INVALID_GENDER() {
    return 1120;
  }

  static get ACCOUNT_INVALID_CPF() {
    return 1121;
  }

  static get ACCOUNT_INVALID_GOOGLE_ID() {
    return 1122;
  }

  static get ACCOUNT_PHONE_EXISTS() {
    return 1123;
  } //Store


  static get STORE_CLOSED() {
    return 1200;
  } //Delivery


  static get OUT_OF_REGION() {
    return 1300;
  }

  static get EMPTY_DELIVERY() {
    return 1301;
  }

  static get ORDER_DELIVERY_MIN_AMOUNT() {
    return 1302;
  }

  static get DELIVERY_OUT_OF_REGION() {
    return 1303;
  }

  static get DELIVERY_MIN_AMOUNT_REGION() {
    return 1304;
  }

  static get DELIVERY_NOT_DEFINED() {
    return 1305;
  }

  static get DELIVERY_ADDRESS_NOT_DEFINED() {
    return 1306;
  }

  static get DELIVERY_GEOLOCATION_NOT_DEFINED() {
    return 1307;
  }

  static get DELIVERY_INVALID() {
    return 1308;
  }

  static get DELIVERY_STRIP_NOT_DEFINED() {
    return 1309;
  } //Gift


  static get INVALID_GIFT() {
    return 1400;
  } //Gift


  static get INVALID_CHECKOUT() {
    return 1500;
  } //Cart


  static get EMPTY_CART() {
    return 1600;
  }

  static get INVALID_CART() {
    return 1601;
  } //Payment


  static get PAYMENT_METHOD_NOT_ALLOWED() {
    return 1700;
  }

  static get EMPTY_PAYMENT() {
    return 1701;
  } //DB


  static get DB_CONNECTION() {
    return 400;
  } //Store


  static get STORE_CONNECTION() {
    return 10001;
  } //Account


  static get ACCOUNT_INVALID_START_DATE() {
    return 5021;
  }

  static get ACCOUNT_INVALID_END_DATE() {
    return 5022;
  }

  static get ACCOUNT_OVERFLOW_REGISTER() {
    return 5023;
  }

  static get ACCOUNT_REQUIRED_ADDRESS() {
    return 5024;
  }

  static get ACCOUNT_ADDRESS_ERROR() {
    return 5025;
  }

  static get ACCOUNT_INVALID_RECOVER_TOKEN() {
    return 5029;
  }

  static get ACCOUNT_REGISTER_FAIL() {
    return 5032;
  }

  static get ADDRESS_DEFAULT() {
    return 5000;
  }

  static get ADDRESS_REQUIRED_CITY_OR_DISTRICT() {
    return 5001;
  }

  static get ADDRESS_REQUIRED_ADDRESS_OR_NUMBER() {
    return 5002;
  }

  static get ADDRESS_CITY_OR_DISTRICT_NOT_MATCH_REGION() {
    return 5003;
  }

  static get ADDRESS_EMPTY_USER_INFO() {
    return 5004;
  }

  static get ADDRESS_NOT_FOUND() {
    return 5005;
  }

  static get ORDER_EMPTY() {
    return 5000;
  }

  static get ORDER_UNDEFINED_USER() {
    return 5010;
  }

  static get ORDER_NOT_FOUND() {
    return 5011;
  }

  static get ORDER_REQUIRED_FIELD() {
    return 5012;
  }

  static get ORDER_INVALID_FIELD() {
    return 5020;
  }

  static get ORDER_REQUIRED_ID() {
    return 5024;
  }

  static get CART_INVALID_REQUEST() {
    return 6100;
  }

  static get CART_REQUIRED_FIELDS() {
    return 6111;
  }

  static get CART_INVALID_STRUCTURE_REQUEST() {
    return 6110;
  }

  static get CART_EMPTY_PRODUCT() {
    return 6101;
  }

  static get CART_PRODUCT_NOT_FOUND() {
    return 6000;
  }

  static get CART_STEP_EDGE_SIZE_NOT_FOUND() {
    return 6001;
  }

  static get CART_STEP_INGREDIENT_NOT_FOUND() {
    return 6002;
  }

  static get CART_STEP_EMPTY_INGREDIENT() {
    return 6003;
  }

  static get CART_LOYALTY_NOT_ALLOWED() {
    return 6010;
  }

  static get CART_PRODUCT_STEP_NOT_DEFINED() {
    return 6020;
  }

  static get CART_STEP_NOT_FOUND() {
    return 6021;
  }

  static get CART_PRODUCT_STEP_REQUIRED_PRODUCTS() {
    return 6122;
  }

  static get CART_PRODUCT_NOT_ALLOW_EDGE() {
    return 6022;
  }

  static get CART_PRODUCT_NOT_ALLOW_EDGE_DIVISION() {
    return 6023;
  }

  static get CART_PRODUCT_MAX_DIVISION_EXECEEDED() {
    return 6024;
  }

  static get CART_PRODUCT_INVALID_DIVISION() {
    return 6025;
  }

  static get CART_STEP_ITEM_INVALID_QUANTITY() {
    return 6026;
  }

  static get CART_STEP_REQUIRED_INFO_EXTRA() {
    return 6200;
  }

  static get CART_STEP_EMPTY_INFO_EXTRA() {
    return 6201;
  }

  static get CART_STEP_INVALID_INFO_EXTRA() {
    return 6202;
  }

  static get CART_NOT_FOUND_SIZE() {
    return 6030;
  }

  static get CART_PRODUCT_INGREDIENT_NOT_FOUND() {
    return 6301;
  }

  static get CART_EMPTY_PRODUCT_INGREDIENT() {
    return 6302;
  }

  static get CHECKOUT_INTERNAL_ERROR() {
    return 5000;
  }

  static get CHECKOUT_ITEM_NOT_FOUND_TO_PROCESS() {
    return 5001;
  }

  static get CHECKOUT_ITEM_NOT_FOUND_TO_SAVED() {
    return 5002;
  }

  static get CHECKOUT_MINIMAL_VALUE_NOT_REACHED() {
    return 5003;
  }

  static get CHECKOUT_INVALID_ORDER() {
    return 5005;
  }

  static get CHECKOUT_PAYMENT_NOT_DEFINED() {
    return 5006;
  }

  static get CHECKOUT_PAYMENT_SUM_NOT_MATCH() {
    return 5007;
  }

  static get CHECKOUT_USER_NOT_FOUND() {
    return 5008;
  }

  static get CHECKOUT_ORDER_FAIL() {
    return 5009;
  }

  static get CHECKOUT_NOT_VERIFIED_ITEM() {
    return 5010;
  }

  static get CHECKOUT_REQUIRED_FIELD() {
    return 5018;
  } // Schedule


  static get SCHEDULE_NOT_FOUND() {
    return 7000;
  }

  static get SCHEDULE_ALREADY_EXECUTED() {
    return 7001;
  }

  static get SCHEDULE_ID_ALREADY_EXISTS() {
    return 7002;
  } // Survey


  static get SURVEY_NOT_FOUND() {
    return 8000;
  }

  static get SURVEY_ANSWER_NOT_FOUND() {
    return 8001;
  } //Marketing


  static get MARKETING_INVALID_FIELD() {
    return 9000;
  } //Juno


  static get JUNO_ACCOUNT_NOT_FOUND() {
    return 10000;
  }

  static getMessage(messageCode, lang = 'en_en') {
    messageCode = messageCode || ExceptionCode.DEFAULT;
    return _ExceptionMessages.default[messageCode][lang || 'en_en'];
  }

}

exports.ExceptionCode = ExceptionCode;